import { reduxActions as ATTRIBUTE } from "_constants/attribute.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import initialAttributeState from "../attribute.initialState";

const addGlobal = {
  [ATTRIBUTE.ADD_GLOBAL_STARTED]: (state) => ({
    ...state,
    post: {
      ...state.post,
      status: LOADING
    }
  }),

  [ATTRIBUTE.ADD_GLOBAL_SUCCESS]: (state, { payload }) => ({
    ...state,
    post: {
      ...state.post,
      data: payload?.data ?? null,
      status: SUCCESS
    },
    all: {
      ...state.all,
      data: payload?.data?.length && state.all.data?.length ? 
          [...state.all.data, ...payload.data]
        :
          state.all.data
    }
  }),

  [ATTRIBUTE.ADD_GLOBAL_FAIL]: (state, { payload }) => ({
    ...state,
    post: {
      ...state.post,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [ATTRIBUTE.ADD_GLOBAL_RESET]: (state) => ({
    ...state,
    post: initialAttributeState.post
  })
}

export default addGlobal;
